import React, { useState } from 'react';
import Modal from 'react-modal';
import { toast } from 'react-toastify';

export default function ArchiveAdditionalDocumentModal({
    parentId,
    onCancel,
    onSuccess,
    show,
    additionalDocument
}) {
    const [submitting, setSubmitting] = useState(false);

    const errorToaster = () => toast.error(<div>An error occurred, please try again</div>);

    const onConfirm = async () => {
        setSubmitting(true)

        try {
            const response = await axios.delete(route('web-api.additional-documents.destroy', additionalDocument.additional_document_id));

            if (200 <= response.status < 300) {
                onSuccess()
            } else {
                errorToaster()
            }
        } catch (exception) {
            console.log(exception)
            errorToaster()
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => onCancel()}
            contentLabel={"Create Additional Document"}
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal allow-overflow'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content">
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h4 className="modal-title text-eh-navy">
                        Delete Additional Document
                    </h4>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <p className="text-eh-navy">
                        Are you sure you would like to delete {additionalDocument.file_name}? Please note that existing Templates and Quotes will also have this document removed.
                    </p>
                </div>
                <div className="modal-footer m-0 p-0 d-flex gap-4 border-0">
                    <button
                        type="button"
                        data-dismiss="modal"
                        className="btn btn-outline-eh-off-black px-3 mr-3"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-danger py-0 px-3 ml-0 py-0"
                        onClick={onConfirm}
                        disabled={submitting}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </Modal>
    );
}
